"use client";

import { useLocale } from "./LocaleProvider";

const TEXT = {
  en: "EGODENT • DENTAL • MEDICAL • DENTAL IMPLANTS • ORTHODONTICS • COSMETIC DENTISTRY • SAME DAY GP • GYNAECOLOGY • DERMATOLOGY • HAIR TRANSPLANT • LABORATORY • ",
  ro: "EGODENT • STOMATOLOGIE • MEDICAL • IMPLANTURI DENTARE • ORTODONȚIE • STOMATOLOGIE ESTETICĂ • MEDIC DE FAMILIE ÎN ACEEAȘI ZI • GINECOLOGIE • DERMATOLOGIE • TRANSPLANT DE PĂR • LABORATOR • ",
} as const;

export default function PromoBanner() {
  const text = TEXT[useLocale()];

  return (
    <section className="relative z-20 -mt-[3.2rem] md:-mt-[2.6rem]">
      <div className="overflow-hidden bg-[#27E8A7] py-7 select-none pointer-events-none">
        <div className="flex whitespace-nowrap animate-marquee">
          <span className="font-semibold italic tracking-wide text-black text-2xl md:text-3xl">
            {text.repeat(10)}
          </span>
          <span
            aria-hidden="true"
            className="font-semibold italic tracking-wide text-black text-2xl md:text-3xl"
          >
            {text.repeat(10)}
          </span>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
      `}</style>
    </section>
  );
}
